import { useState, useEffect } from 'react';
import { CircularProgress, CircularProgressProps, Grow, SvgIconProps } from '@mui/material';

import CheckCircleIcon from 'modules/common/components/Icons/CheckCircleIcon';

type CheckmarkLoadingAnimatedProps = {
    slotProps?: {
        circularProgress?: CircularProgressProps;
        icon?: SvgIconProps;
    };
    timeout?: number;
    offset?: number;
};

export default function CheckmarkLoadingAnimated({
    slotProps,
    timeout = 700,
    offset = 1000,
}: CheckmarkLoadingAnimatedProps) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, timeout);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <>
            {isLoading && <CircularProgress {...slotProps?.circularProgress} />}
            <Grow in={!isLoading} timeout={timeout + offset} appear unmountOnExit>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CheckCircleIcon {...slotProps?.icon} />
                </div>
            </Grow>
        </>
    );
}
